import { useState, useEffect, forwardRef,useImperativeHandle} from 'react';
import { Button, Spinner } from 'react-bootstrap';
import {
  COffcanvas,
  COffcanvasHeader,
  COffcanvasTitle,
  COffcanvasBody,
} from "@coreui/react";

import IconButton from '../IconButton/IconButton';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import "./Simplebar.style.css";
import { useTheme } from '../../Hooks';
import { SvgComponent } from '../SvgComponent/SvgComponent';

export const Simplebar = forwardRef(
  (
    {
      showScrollX,
      showScrollY,
      backdrop,
      placement = "end",
      portal = true,
      visible, 
      customHeight = undefined,
      title,
      setShow,
      children,
      noPadding = false,
      size = "md",
      customSize = undefined,
      hideCallback = () => {},
      btnLeft = {
        show: true,
        label: "Aceptar",
        func: (e) => {},
        isComponent: false,
        btnStyle: {},
      },
      btnRight = {
        show: true,
        label: "Aplicar",
        func: (e) => {},
        isComponent: false,
        btnStyle: {},
      },
      useLoading = false,
      useVendorTheme = false,
        scrool = false
    },
    ref
  ) => {
    const [displayMode, setDisplayMode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const styleVars = {
      "--cui-offcanvas-width": customSize ?? getSize(size),
      "--cui-offcanvas-height" : '210vw'
    };
    const paddingStyleVars = {
      "--cui-offcanvas-padding-x": "0.2rem",
      "--cui-offcanvas-padding-y": "0.2rem",
    };
    const footerStyle = {
      position: "relative",
      padding: "0.3rem",
      left: 0,
      bottom: 0,
      width: "100%",
      backgroundColor: "lightgrey",
      color: "white",
    };
    const [color1, setColor1] = useState(window.color1);
    const { theme } = useTheme();

    useEffect(() => {
      if(useVendorTheme){
        if(window.esClaro){
          setColor1('#D52B1E')
        }else{
          setColor1('rgb(241, 97, 1)')
        }
      }
    }, [])
    useEffect(() => {
      setDisplayMode("");
    }, [visible]);
    useImperativeHandle(ref, () => ({
      showLoading: (v) => {
        setIsLoading(v);
      },
    }));

    function getSize(s) {
      switch (s) {
        case "xxxl":
          return "95vw";
        case "xxl":
          return "80vw";
        case "xl":
          return "70vw";
        case "lg":
          return "50vw";
        case "md":
          return "30vw";
        default:
          return "20vw";
      }
    }
    return (
      <>
        <COffcanvas 
          // eslint-disable-next-line no-restricted-globals
          scroll={scroll}
          backdrop={backdrop}
          placement={placement}
          portal={portal}
          visible={visible}
          onHide={() => {
            hideCallback();
            setShow(false);
            setDisplayMode("none");

            if (useLoading) setIsLoading(false);
          }}
          style={noPadding ? { ...styleVars, ...paddingStyleVars,height: '800px' } : styleVars}
        >
          <COffcanvasHeader
            style={{ backgroundColor: color1, padding: "16px" }}
          >
            <COffcanvasTitle
              style={{
                marginTop: "0",
                color: "white",
                textShadow: "unset",
                fontSize: "18px",
                marginBottom: "0px"
              }}
            >
              {title}
            </COffcanvasTitle>
            <IconButton
              onClick={() => {
                setShow(false);
                setDisplayMode("none");
                if (useLoading) setIsLoading(false);
              }}
            >
              <SvgComponent
                iconName="x"
                height="20"
                width="20"
                fill="#fff"
              />
            </IconButton>
          </COffcanvasHeader>
          {isLoading && (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                zIndex: "9999999",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner
                style={{
                  width: "4rem",
                  height: "4rem",
                  color: color1,
                }}
                animation="border"
              />
            </div>
          )}
          <COffcanvasBody
            style={
              isLoading === true
                ? {
                    WebkitFilter: "blur(2px)",
                    filter: "blur(2px)",
                    overflowX: "hidden",
                  }
                : {
                    overflowX: showScrollX ? "auto" : "hidden",
                    overflowY: showScrollY ? "auto" : "hidden",
                    margin: 0,
                    padding: 0,
                  }
            }
          >
            <div style={{ display: displayMode }}>{children}</div>
          </COffcanvasBody>
          <div
            id="canvasFooter"
            style={btnLeft.show || btnRight.show ? footerStyle : {}}
          >
            <div
              className={`d-flex ${
                btnLeft.isCenter
                  ? "justify-content-center"
                  : "justify-content-center"
              }`}
            >
              {btnLeft.show && !btnLeft.isComponent ? (
                <Button
                  onClick={btnLeft.func}
                  style={{
                    backgroundColor: color1,
                    borderColor: color1,
                  }}
                  disabled={isLoading}
                >
                  {btnLeft.label}
                </Button>
              ) : (
                btnLeft.isComponent && (
                  <AnimatedIconButton
                    onClick={btnLeft.func}
                    size={btnLeft.size}
                    height={btnLeft.height}
                    width={btnLeft.width}
                    message={btnLeft.message}
                    disabled={isLoading}
                    iconName={btnLeft.iconName}
                  />
                )
              )}
              {btnRight.show && !btnRight.isComponent ? (
                <Button
                  onClick={btnRight.func}
                  variant={"outline-secondary"}
                  className="text-white"
                  disabled={isLoading}
                >
                  {btnRight.label}
                </Button>
              ) : (
                btnRight.isComponent && (
                  <AnimatedIconButton
                    onClick={btnRight.func}
                    size={btnRight.size}
                    height={btnRight.height}
                    width={btnRight.width}
                    message={btnRight.message}
                    disabled={isLoading}
                    iconName={btnRight.iconName}
                  />
                )
              )}
            </div>
          </div>
        </COffcanvas>
      </>
    );
  }
);
